<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/bcInfo.png" alt=""><span>认证信息</span></div>
      <div class="m-nav"><span>证件类型</span><p>居民身份证</p></div>
      <div class="m-nav">
        <span>证件姓名</span>
        <p v-if="USER_INFO.hasNameAccess!=0">{{USER_INFO.realName}}</p>
        <span v-else="" class="m-right-span">请实名认证</span>
      </div>
      <div class="m-nav">
        <span>证件号码</span>
        <p v-if="USER_INFO.hasNameAccess!=0">{{USER_INFO.idCardNum}}</p>
        <span v-else="" class="m-right-span">请实名认证</span>
      </div>
      <div class="m-nav">
        <span>有限期限</span>
        <p v-if="USER_INFO.hasNameAccess!=0">
          {{USER_INFO.hasNameAccessExpireStart ? dayjs(USER_INFO.hasNameAccessExpireStart).format('YYYY-MM-DD') : ''}}
          至
          {{USER_INFO.hasNameAccessExpireEnd | setTime}}
        </p>
        <span v-else=""  class="m-right-span">请实名认证</span>
      </div>
      <div v-if="authUpImage==1" class="m-nav">
        <span>证件照</span>
        <div v-if="USER_INFO.cardPhoto" style="flex: 1;text-align: right">
          <img @click="goPic(0,USER_INFO.cardPhoto)" class="m-nav-pic" :src="USER_INFO.cardPhoto" alt="">
        </div>
        <span v-else="" class="m-right-span">请上传证件照</span>
      </div>
      <div class="m-nav">
        <span>实名状态</span>
        <div style="flex: 1;text-align: right">
          <span style="color:#2B6CF9" v-if="USER_INFO.hasNameAccess==1">已认证</span>
          <span style="color:#FB2927" v-if="USER_INFO.hasNameAccess==2">已过期</span>
          <span style="color:#F19E3B" v-if="USER_INFO.hasNameAccess==0||USER_INFO.hasNameAccess==null">未实名</span>
        </div>
      </div>
    </div>
    <div class="m-box-btn">
      <van-button v-if="USER_INFO.hasNameAccess==0||USER_INFO.hasNameAccess==null" block class="x-btn-log m-btn" @click="realMore()">认证
      </van-button>
      <div class="m-two-btn" v-else="">
        <van-uploader v-show="authUpImage==1&&USER_INFO.hasNameAccess==1" :after-read="afterRead" :multiple="true" :max-count="1" accept="image/*" :before-read="beforeRead">
          <van-button block class="m-btn-default m-btn">{{USER_INFO.cardPhoto ? '修改证件照':'上传证件照'}}</van-button>
        </van-uploader>
        <van-button  block class="x-btn-log m-btn" native-type="button" @click="isUp()">更新</van-button>
      </div>

    </div>
  </div>
</template>

<script>
  import { ImagePreview } from 'vant'
  import { Dialog } from 'vant';
  import { mapMutations,mapGetters } from 'vuex'
  import dayjs from 'dayjs';
  import { JudgeCompress } from '@/assets/js/compress/handleImage'
  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
    },
    computed: {
      ...mapGetters({
        USER_INFO: 'user/userInfo'
      })
    },
    data () {
      return {
        authUpImage: '',
        aiOnOff: 0,
      }
    },
    created () {
      this.getInfo()
      this.isAuth()
    },
    methods: {
      ...mapMutations({
        SET_USER_KEY: 'user/setUserKey'
      }),
      realMore(){
        this.$router.push('/realCard?authUpImage='+this.authUpImage)
      },
      isUp(){
        this.$router.push('/realCard?authUpImage='+this.authUpImage)
      },
      //    获取个人信息
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.SET_USER_KEY({key: 'userInfo', value: res.data ? res.data : ''})
          }
        })
      },
      //是否开启证件照
      isAuth(){
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            this.aiOnOff = res.data.aiOnOff
            this.authUpImage = res.data.authUpImage==1 ? 1 :''
          }
        })
      },
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>4194304){
          this.utils.toastError('文件大小不能超过4MB！')
          return false
        }
        return true
      },
      afterRead(e){
        if(this.aiOnOff==1){     //开启ai制图
          JudgeCompress(e.file,200).then((rel)=>{
            let arr = rel.split('base64,')
            let oneTitle = arr[0]+'base64,'
            let towTitle = arr[1]
            this.http.postRequest({
              url: 'visitor/remote/res/idPhotoMaker',
              msg:{base64:towTitle},
              special:true,
            },true).then((res)=>{
              if(res.code!=200){
                Dialog.alert({
                  title:'证件照上传失败',
                  message: res.msg||res.code,
                  confirmButtonColor: '#2B6CF9',
                }).then(() => {})
              }
              if(res.code==200){
                let aiUrl = JSON.parse(res.data).image
                this.upFiles(aiUrl,oneTitle)
              }
            })
          })
        } else {
          this.upFiles(e.content)
        }
      },
      upFiles(e,oneTitle){
        let fils = ''
        if(oneTitle){
          fils = oneTitle + e
        }else {
          fils = e
        }
        this.http.postRequest({
          url: 'app/faceAuth/cardPhotoFace',
          msg: {imgBase64:fils},
          special:true,
        },true).then((res)=>{
          if(res.code==500){
            Dialog.alert({
              title: '证件照修改失败',
              message: res.msg||res.code,
              confirmButtonColor: '#2B6CF9',
            }).then(() => {})
          }
          if(res.code==200){
            this.getInfo()
            this.utils.toastSuccess('修改成功')
          }
        },true)
      },
      goPic (i,y) {
        ImagePreview({
          images: [y],
          startPosition: i,
        })
      },
    },
    filters: {
      setTime:(value) =>{
        if (!value) return ''
        let time  = dayjs(value).format()
        let time1 = dayjs('2099-12-31 00:00:00').format()
        if(time == time1){
          return '长期'
        }else {
          return dayjs(value).format('YYYY-MM-DD')
        }
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    background: #F4F6F9;
    padding: 0 12px 90px 12px;
    background: #F4F6F9;
    .m-bg-cover {
      position: absolute;
      left: 0;
      right: 0;
      height: 180px;
      background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
      z-index: -1;
    }
    .m-info-box {
      background: #ffffff;
      border-radius: 4px;
      padding: 15px 12px 0 12px;
      margin-top: 18px;
      .m-info-tit{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
      .m-nav{
        padding-bottom: 20px;
        display: flex;
        >span{
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        >p{
          flex: 1;
          text-align: right;
        }
        .m-right-span{
          flex: 1;
          text-align: right;
          color: #999999;
        }
        .m-nav-pic{
          width: 70px;
          height: 90px;
          object-fit: cover;
        }
      }
    }
    .m-box-btn {
      width: 100%;
      padding: 20px 0px 0px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .m-btn {
        width: 144px;
        margin: 0 auto;
      }
      .m-two-btn{
        display: flex;
        .m-btn-default{
          border-radius: 8px;
          background: #ffffff;
          color: #2B6CF9;
          margin-right: 20px;
        }
      }
    }
  }
</style>

